import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { defineMessages, useIntl } from 'dibs-react-intl';

import { SbSharedRefineMenuFacet } from '../SbSharedRefineMenu/SbSharedRefineMenuFacet/SbSharedRefineMenuFacet';
import { SORT } from '../SbSharedRefineMenu/sbSharedRefineMenuConstants';
import { SbSharedRefineMenuRadioSelect } from '../SbSharedRefineMenu/SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelect';
import { SbRespRefineMenuFilterSortFacet_itemSearch } from './__generated__/SbRespRefineMenuFilterSortFacet_itemSearch.graphql';

type Props = {
    itemSearch: SbRespRefineMenuFilterSortFacet_itemSearch;
};

const messages = defineMessages({
    title: {
        id: 'sb.SbRespRefineMenuFilterSortFacet.title',
        defaultMessage: 'Sort By',
    },
});

const SbRespRefineMenuFilterSortFacetComponent: FC<Props> = ({ itemSearch }) => {
    const { displayUriRef = '', sort } = itemSearch;
    const currentOption = sort?.currentOption;
    const sortOptions = sort?.options;
    const intl = useIntl();

    if (!currentOption || !sortOptions) {
        return null;
    }

    return (
        <SbSharedRefineMenuFacet
            storageFacetKey={SORT}
            title={intl.formatMessage(messages.title)}
            appliedFiltersComponent={currentOption?.displayName}
            initiallyExpanded={false}
        >
            <SbSharedRefineMenuRadioSelect
                filterName={SORT}
                valuesToShow={sortOptions}
                displayUriRef={displayUriRef}
                canBeDismissed={false}
                appliedFilterValues={[currentOption]}
            />
        </SbSharedRefineMenuFacet>
    );
};

export const SbRespRefineMenuFilterSortFacet = createFragmentContainer(
    SbRespRefineMenuFilterSortFacetComponent,
    {
        itemSearch: graphql`
            fragment SbRespRefineMenuFilterSortFacet_itemSearch on ItemSearchQueryConnection {
                displayUriRef
                sort {
                    options {
                        urlLabel
                        linkReference
                        displayName
                    }
                    currentOption {
                        urlLabel
                        displayName
                    }
                }
            }
        `,
    }
);
